import { render, staticRenderFns } from "./Fiche.vue?vue&type=template&id=d52aa230"
import script from "./Fiche.vue?vue&type=script&lang=ts"
export * from "./Fiche.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports